<template>
  <div id="landing-page">
    <div id="intro-wrapper">
      <div id="intro">
        <img alt="Life Quote logo" src="../assets/logo.png"/>
        <div id="intro-text">
          <div>
            <p>
                LifeQuote Administration is the only end-to-end service taking away the hassle and risk of writing protection, freeing you to find and advise clients.
            </p>
            <p>
                We make administering protection as easy as possible, managing the full application: from submission to the insurer, chasing GPs and dealing with underwriters. Using LifeQuote to administer your protection business saves you three hours per case*, freeing you to meet and advise more clients.
            </p>
            <p>
                Use the Protection Revenue Opportunity (PRO) tool to input some basic details about your business and see how much more money you can earn when using LifeQuote Administration. 
            </p>
          </div>
        </div>
        <BtnNext title="Get Started" currentPage="landing-page" />
      </div>
    </div>
    <div id="footer">
      <div id="disclaimer">
        <div id="disclaimer-text">
          * using LifeQuote Administration saves advisers, on average, three hours per case. May 2022.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BtnNext from './BtnNext.vue'
export default {
  //name: 'HelloWorld',
  props: {
  },
  components: {
    BtnNext
  }
}
</script>